import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { ManureSpaceApiService } from 'src/app/manure-space/services/manure-space-api.service';
import { setManureSpaceComment } from 'src/app/manure-space/store/manure-space.actions';
import * as ManureSpaceSelectors from 'src/app/manure-space/store/manure-space.selectors';
import { SiteState } from 'src/app/shared/models';

@Component({
  selector: 'app-fertilizer-comment',
  templateUrl: './fertilizer-comment.component.html',
  styleUrls: ['./fertilizer-comment.component.scss'],
  standalone: false,
})
export class FertilizerCommentComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly manureSpaceApi = inject(ManureSpaceApiService);

  comment = new FormControl('');
  postDisabled = false;
  private readonly destroyed$ = new Subject<boolean>();
  private readonly manureSpaceComment$ = this.store.select(
    ManureSpaceSelectors.selectManureSpaceComment,
  );
  private manureSpaceId: number;

  ngOnInit() {
    this.manureSpaceComment$.pipe(takeUntil(this.destroyed$)).subscribe((comment: string) => {
      this.comment.setValue(comment);
    });

    this.store
      .select(ManureSpaceSelectors.selectActiveTabManureSpace)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((manureSpace) => {
        if (manureSpace.state === 'loaded' && manureSpace.data) {
          this.manureSpaceId = manureSpace.data.id;
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save() {
    if (this.postDisabled) {
      return;
    }
    this.postDisabled = true;
    this.manureSpaceApi
      .postComment(this.manureSpaceId, this.comment.value)
      .pipe(takeUntil(this.destroyed$), delay(300))
      .subscribe(() => {
        this.postDisabled = false;
        this.store.dispatch(setManureSpaceComment({ comment: this.comment.value }));
      });
  }
}
